import { Component } from "vue";
import { HelpContentFactory } from "@/shared/help/services/HelpContentFactory";
import { CalculationHelpContentType } from "../models/CalculationHelpContentType";



export class CalculationHelpContentFactory extends HelpContentFactory<CalculationHelpContentType> {

    public cdnContentPath: string = "custom_calculations";

    public async tryGetStaticHelpContentByType(type: CalculationHelpContentType | string): Promise<Component | null> {
        switch (type) {
            case CalculationHelpContentType.Default:
            default:
                return null;
        }
    }

}